import React from 'react';

function ArrayFieldDescription({ DescriptionField, fieldPathId, description, registry }) {
  if (!description) {
    return null;
  }

  const id = `${fieldPathId.$id}__description`;

  return <DescriptionField id={id} description={description} registry={registry} />;
}

export default ArrayFieldDescription;
